var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn focus:outline-none border-0 p-0 flex items-center relative z-20",on:{"click":_vm.onClick}},[_c('Icon',{attrs:{"name":"backarrow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }